import { Component, Input } from '@angular/core';
import { Stream } from '../../models/Stream';
import { StreamProvider } from '../../providers/stream/stream';
import { LoadingController, ToastController } from 'ionic-angular';
@Component({
    selector: 'stream-list',
    templateUrl: 'stream-list.html'
})
export class StreamListComponent {
    streams: Stream[] = [];
    allStreams: Stream[] = [];
    hasLoaded: boolean = false;

    constructor(
        public streamsCtrl: StreamProvider,
        public loadingCtrl: LoadingController,
        public toastCtrl: ToastController
    ) {

    }

    ngOnInit(){
        let loader = this.loadingCtrl.create();
        loader.present();

        this.streamsCtrl.getAllStreams().subscribe(streams => {
            this.allStreams = streams;
            this.streams = [];
            this.hasLoaded = true;
            this.loadMoreStreams();
            loader.dismiss();
        }, error => {
            this.toastCtrl.create({ message: error, duration: 3000 }).present();
            loader.dismiss();
        })
    }

    getMoreItems(infiniteScroll) {
        this.loadMoreStreams();
        infiniteScroll.complete();
    }
    loadMoreStreams() {
        let start = this.streams.length;
        let end = start + 14;

        if (end >= this.allStreams.length) {
            end = this.allStreams.length - 1;
        }
        for (let i = start; i <= end; i++) {
            this.streams.push(this.allStreams[i]);
        }
    }
    getMoreItemsButton(event) {
        this.loadMoreStreams();
    }

}



// WEBPACK FOOTER //
// ./src/components/stream-list/stream-list.ts